import { EntitySelect, EntitySelectEntity } from '@factorialco/f0-react/dist/experimental'

import i18n from 'modules/core/lib/i18n'

interface RoleData {
  id: string
  name: string
}

interface LegacyRoleSelectorProps {
  availableRoles: RoleData[] | undefined
  error?: string | boolean
  disabled?: boolean
  isLoading: boolean
  onChange: (value: string | null) => void
  value?: string | number | null
}

const LegacyRoleSelector = ({
  availableRoles = [],
  error,
  disabled,
  isLoading,
  onChange,
  value,
}: LegacyRoleSelectorProps) => {
  const stringValue = typeof value === 'number' ? String(value) : value
  const selectedRole = stringValue
    ? availableRoles.find((role) => role.id === stringValue)
    : undefined
  const selectedEntities = selectedRole
    ? [{ id: selectedRole.id, name: selectedRole.name, avatar: undefined }]
    : []

  return (
    <EntitySelect
      label={i18n.t('workflows.sidepanel.approval.strategies.selectors.roles')}
      hideLabel
      size="md"
      loading={isLoading}
      disabled={disabled}
      entities={availableRoles.map(({ id, name }) => ({
        avatar: undefined,
        expanded: false,
        id,
        name,
      }))}
      notFoundSubtitle={i18n.t(
        'workflows.sidepanel.approval.strategies.selectors.roles_not_found_subtitle'
      )}
      notFoundTitle={i18n.t(
        'workflows.sidepanel.approval.strategies.selectors.roles_not_found_title'
      )}
      onGroupChange={() => {}}
      onItemExpandedChange={() => {}}
      onSelect={(selection: EntitySelectEntity | null) => {
        onChange(selection?.id ? String(selection.id) : null)
      }}
      searchPlaceholder={i18n.t(
        'workflows.sidepanel.approval.strategies.selectors.roles_search_placeholder'
      )}
      selectedEntities={selectedEntities}
      selectedLabel={i18n.t(
        'workflows.sidepanel.approval.strategies.selectors.roles_selected_label'
      )}
      singleSelector
      placeholder={i18n.t('workflows.sidepanel.approval.strategies.selectors.roles_placeholder')}
      selectedItemsCopy={i18n.t(
        'workflows.sidepanel.approval.strategies.selectors.roles_selected_copy'
      )}
      groups={[]}
      selectedGroup="all"
      clearLabel={i18n.t('workflows.sidepanel.approval.strategies.selectors.roles_clear_label')}
      selectAllLabel={i18n.t(
        'workflows.sidepanel.approval.strategies.selectors.roles_select_all_label'
      )}
      error={error}
    />
  )
}

export default LegacyRoleSelector
